import Swiper from "../../external/swiper";

export class TextGridBlocks
{

    constructor(textGridNode)
    {
        this.root_node = textGridNode;

        if(!this.root_node) return;

        this.slider_node = this.root_node.querySelector('.swiper-container');
        this.slider = null;
        window.addEventListener('resize', () => {
            if(window.innerWidth < 1200){
                if(this.slider === null) {
                    this.init_slider();
                }
            } else {
                if(this.slider !== null) {
                    this.slider.destroy(true, true);
                    this.slider = null;
                }
            }
        });

        if(window.innerWidth < 1200) {
            this.init_slider();
        }

    }

    init_slider()
    {
        this.slider = new Swiper(this.slider_node, {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 32,
            navigation: {
                nextEl: this.root_node.querySelector('.pagination-button--next'),
                prevEl: this.root_node.querySelector('.pagination-button--prev')
            }
        });
    }


}
